import React from 'react';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Resume from './components/Resume';
import Footer from './components/Footer';

const App = () => {
    return (
        <div>
            <Header />
            <Home />
            <About />
            <Projects />
            <Resume />
            <Footer />
        </div>
    );
};

export default App;
